export default __webpack_public_path__ + "static/media/imgLight3.00415c2f.png";